"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { BrowsersModel, CountriesModel, CountryOsModel, GoodSpecModel, LanguageModel, ParentCategoryModel, RegionModel, RemoteRegionModel, ResolutionModel, TimezoneModel, TopCategoryModel } from "@/models/paymentModels/SelectOptions.model";
export let PaymentDefaultModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    //最顶层ID
    this.name = "";
    //最顶层name
    this.topGroup = new TopCategoryModel();
    //最顶层对象
    this.region = new ParentCategoryModel();
    //地区对象
    this.remote = new RemoteRegionModel();
    //是否远程对象
    this.type = null;
    //型号对象
    this.region_category = new RegionModel();
    //sku 对象
    this.regionTrees = [];
    //整理后的数据源
    this.country = new CountriesModel();
    //国家对象
    this.language = new LanguageModel();
    //语言对象
    this.timezone = new TimezoneModel();
    //时区对象
    this.is_auto_timezone = false;
    //是否显示自动时区开关
    this.auto_timezone = false;
    //自动时区开关值
    this.show_auto_renew = false;
    //是否显示自动续费开关
    this.virtual_desktop_info = [];
    //续费的vd信息块
    this.payment_product = new GoodSpecModel();
    //选中的sku对象
    this.payment_quantity = 1;
    //购买的数量
    this.payment_coins = 0;
    //金豆余额
    this.payment_goldbean_used = 0;
    //支付时的金豆
    this.payment_discount_code = "";
    //折扣吗
    this.payment_type = "alipay";
    //支付方式
    this.payment_cost = 0;
    //价格
    this.payment_goldbean_limit = 0;
    //金豆使用限制
    this.payment_original_cost = 0;
    //原价
    this.payment_goldbean_left = 0;
    //剩余金豆数量
    this.payment_code_error = null;
    //优惠码输入错误的提示
    this.payment_code_type = null;
    //折扣码类型(判断是折扣码还是优惠券)
    this.payment_coupon = null;
    //使用的优惠券对象
    this.payment_vdcard = null;
    //使用的vd卡对象
    this.payment_auto_renew = false;
    //是否自动续费开关
    this.payment_agreement = false;
    //是否同意许可协议
    this.payment_auto_resolution = true;
    //是否自动分辨率开关
    this.payment_ratio = new ResolutionModel();
    //浏览器分辨率
    this.browser = new BrowsersModel();
    //浏览器(目前弃用)
    this.system = new CountryOsModel();
    //操作系统版本（win10-64、win7 -32）
    this.payment_loading = false;
    //load状态
    this.payment_search_params = {};
    //搜索对象
    this.payment_region_id = null;
  }
  //最底层id，搜索sku用
};
PaymentDefaultModel.model = "payment.default";
PaymentDefaultModel = __decorateClass([
  Annotation.ModelMeta
], PaymentDefaultModel);
